import { arrayIsNullOrEmpty, mapAddressTypeNameToCategory, } from './helpers'
import { MARKER_TYPES, DEFAULT_MARKER_URL } from '../constants/other'


// eslint-disable-next-line no-undef
export const getWashingtonBounds = () => {
  let result = null
  try {
    result = new google.maps.LatLngBounds(
      { lat: 45.48899999999999, lng: -124.7739025026037, },
      { lat: 49.00165866869968, lng: -116.9000000000000, },
    ) 
  } catch {
    console.warn('Google maps lib not loaded, unable to get WA bounds.')
  }
  return result
}


export const isValidCoord = (lat, lon) =>
  lat 
  && lon 
  && (lat <= 90 && lat >= -90 )
  && (lon <= 180 && lon >= -180)

/**
 * Create new bounds or extend currentBound
 * @param {progam} program 
 * @param {bounds} currentBound 
 */
export const getOrExtendAddressListBounds = (addresses = [], currentBound = null) => {
  let result = null
  try {
    // eslint-disable-next-line no-undef
    let defaultResult = getWashingtonBounds()
    if (arrayIsNullOrEmpty(addresses)) {
      return currentBound || defaultResult
    }
    result = currentBound || new google.maps.LatLngBounds() //eslint-disable-line no-undef
    addresses.forEach((a) => {
      if (!a.lat || !a.lon){
        return
      }
      const latLng = { lat: a.lat, lng: a.lon, }
      if (!result.contains(latLng)){
        result.extend(latLng)
      }
    })
  } catch {
    console.warn('Google maps lib not loaded, unable to extend address list bounds.')
  }
  return result
}

export const getMarkerColorForAddrType = (type) => {
  const typeToCheck = mapAddressTypeNameToCategory(type)
  let typeColor
  switch (typeToCheck){
  case 'institution':
  case 'class site':
    typeColor = 'green'
    break
  case 'how_to_apply':
  case 'contact':
    typeColor = 'blue'
    break
  case 'session':
  case 'worksite':
    typeColor = 'red'
    break
  case 'partner':
    typeColor = 'yellow'
    break
  default:
    typeColor = 'black'
  }
  return typeColor
}

export const getMarkerUrl = (programType, addressType) => {
  var type = MARKER_TYPES.filter(function (item) {
    return item.result === programType && addressType.indexOf(item.location) >= 0
  })

  if (type.length > 0) {
    return type[0].url
  }
  return DEFAULT_MARKER_URL
}

export const inGreaterWA = (point) => {
  let result = false
  try {
    if (!point) {
      return false
    }
    var lat = point.lat
    var lon = point.lon ?? point.lng
  
    if (!lat || !lon) {
      return false
    }
    const wabound = getWashingtonBounds()
    result = wabound.contains({ lat, lng: lon, })
    // return lat < 49.167615 && lat > 45.481523 && lon > -124.261828 && lon < -116.774065
  } catch {
    console.warn('Google maps lib not loaded, unable to check if bounds are in WA.')

  }
  return result
}


export const geocode = (address, setResult) => {
  try {    
    var geocoder = new google.maps.Geocoder()
    const waBounds = getWashingtonBounds()
    geocoder.geocode({ 
      address               : address, 
      bounds                : waBounds,
      componentRestrictions : {
        country            : 'US',
      },
    }, (results, status) => {
      if (status === 'OK') {
        var point = results[0].geometry.location.toJSON()
        setResult(results[0])
        return point
      } else {
        setResult(null)
        return null
      }
    })
  } catch {
    console.warn('Google maps lib not loaded, unable to use Geocoding API.')
  }
}

export const updateMapWithMaxZoom = (map, bnd, cen, maxZoom = 11) => {
  let centerToSet = null
  if (cen) {
    centerToSet = cen
  } else if (bnd) {
    centerToSet = bnd.getCenter()
  }

  const oldZoom = map.getZoom()
  if (centerToSet) {
    if (bnd) {
      google.maps.event.addListenerOnce(map, 'center_changed', function () {
        if (maxZoom) {
          google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
            const cz = map.getZoom()
            if (cz > maxZoom) {
              // google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
              //   drawBounds(map, map.getBounds(), '#FFFFFF', 2)
              // })
              map.setZoom(Math.max(oldZoom, maxZoom))
            } 
            // else {
            //   drawBounds(map, map.getBounds(), '#FFFFFF', 2)
            // }
          })
        }
        map.fitBounds(bnd)
      })
    } else if (maxZoom) {
      google.maps.event.addListenerOnce(map, 'center_changed', function () {
        map.setZoom(maxZoom)
        // drawBounds(map, map.getBounds(), '#FFFFFF', 2)
      })
    }
    map.setCenter(cen)
  } else if (maxZoom) {
    // google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
    //   drawBounds(map, map.getBounds(), '#FFFFFF', 2)
    // })
    map.setZoom(maxZoom)
  }

}

export const updateMap = (map, bnd, cen, zom) => {
  let centerToSet = null
  if (cen) {
    centerToSet = cen
  } else if (bnd) {
    centerToSet = bnd.getCenter()
  }

  if (centerToSet) {
    if (bnd) {
      google.maps.event.addListenerOnce(map, 'center_changed', function () {
        if (zom) {
          google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
            // google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
            //   drawBounds(map, map.getBounds(), '#FFFFFF', 2)
            // })
            map.setZoom(zom)
          })
        }
        map.fitBounds(bnd)
      })
    } else if (zom) {
      google.maps.event.addListenerOnce(map, 'center_changed', function () {
        // google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
        //   drawBounds(map, map.getBounds(), '#FFFFFF', 2)
        // })
        map.setZoom(zom)
      })
    } 
    // else {
    //   google.maps.event.addListenerOnce(map, 'center_changed', function () {
    //     drawBounds(map, map.getBounds(), '#FFFFFF', 2)
    //   })
    // }
    map.setCenter(cen)
  } else if (zom) {
    // google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
    //   drawBounds(map, map.getBounds(), '#FFFFFF', 2)
    // })
    map.setZoom(zom)
  }
}

/**
 * Debug method to draw bounds
 */
export function drawBounds (map, bounds, color = '#FF0000', weight = 2) {
  const plainBounds = bounds.toJSON()
  const flightPlanCoordinates = [
    { lat: plainBounds.north, lng: plainBounds.west, },
    { lat: plainBounds.south, lng: plainBounds.west, },
    { lat: plainBounds.south, lng: plainBounds.east, },
    { lat: plainBounds.north, lng: plainBounds.east, },
    { lat: plainBounds.north, lng: plainBounds.west, },
  ]
  const flightPath = new google.maps.Polyline({
    path          : flightPlanCoordinates,
    geodesic      : true,
    strokeColor   : color,
    strokeOpacity : 1.0,
    strokeWeight  : weight,
  })
  flightPath.setMap(map)
  return flightPath
}

/**
 * Debug method to draw center radius
 */
export function drawCenter (map, center) {
  const cityCircle = new google.maps.Circle({
    strokeColor   : '#FF0000',
    strokeOpacity : 0.8,
    strokeWeight  : 2,
    fillColor     : '#FF0000',
    fillOpacity   : 0.35,
    center        : center,
    radius        : 1000,
  })
  cityCircle.setMap(map)
  return cityCircle
}